import type { SchemaType } from '@based/schema'
import { SchemaToType } from './utils'

export const seoMetaTitle = {
  type: 'string',
  title: 'Meta title',
  description:
    'Overrides the page title shown before the site name. Leave empty to use the default.',
} as const

export const seoMetaDescription = {
  type: 'text',
  title: 'Meta description',
  description:
    'Fully overrides the search engine meta description. Leave empty to use the default.',
} as const

export const pageSeo = {
  path: {
    type: 'alias',
    title: 'Page path',
    description:
      'URL path without domain, e.g. /d/initiatieven or /over-crowdbuilding',
  },
  metaTitle: seoMetaTitle,
  metaDescription: seoMetaDescription,
  active: {
    type: 'boolean',
    title: 'Active',
    description:
      'When enabled, meta title and description overrides apply on the public site',
  },
  createdAt: { type: 'timestamp', on: 'create' },
  updatedAt: { type: 'timestamp', on: 'update' },
} satisfies SchemaType

export type PageSeo = SchemaToType<typeof pageSeo> & {
  id: number
}
